/* moovers — EasySell COD
   1) El botón "COMPLETAR PEDIDO" y el botón COD de la página los pinta la app con
      style inline !important: ningún CSS los gana, así que se reescriben acá.
   2) Textos que la app deja en inglés ("City", "Order Now - Cash on Delivery", "Sold Out").
   Si algún día se cambian estos colores/textos dentro de EasySell, se puede simplificar. */
(function () {
  var ORANGE = '#FF7A00', INK = '#0F0F0F', WHITE = '#FFFFFF';
  var COD_LABEL = 'Pagarlo al recibir';

  function setImp(el, prop, val) { el.style.setProperty(prop, val, 'important'); }

  function pintar() {
    // Botón final del formulario
    document.querySelectorAll('#es-form-button, #easysell .es-cta-btn').forEach(function (b) {
      if (b.getAttribute('style') === b.dataset.mvStyle) return; // ya pintado y la app no lo tocó
      setImp(b, 'background-color', ORANGE);
      setImp(b, 'color', WHITE);
      b.querySelectorAll('[style]').forEach(function (s) { setImp(s, 'color', WHITE); });
      b.dataset.mvStyle = b.getAttribute('style');
    });
    // Botón COD del carrito: principal naranja
    document.querySelectorAll('.es-popup-button-drawer').forEach(function (b) {
      if (b.getAttribute('style') === b.dataset.mvStyle) return;
      setImp(b, 'background', ORANGE);
      setImp(b, 'color', WHITE);
      setImp(b, 'border-radius', '16px');
      setImp(b, 'border-width', '3px');
      setImp(b, 'border-style', 'solid');
      setImp(b, 'border-color', INK);
      setImp(b, 'box-shadow', '4px 4px 0 ' + INK);
      setImp(b, 'font-size', '16px');
      setImp(b, 'font-weight', '800');
      b.dataset.mvStyle = b.getAttribute('style');
    });
    // Botón COD que EasySell agrega en la página de producto y la barra fija
    document.querySelectorAll('.es-popup-button-product, #es-sticky').forEach(function (b) {
      if (b.getAttribute('style') === b.dataset.mvStyle) return;
      setImp(b, 'background', INK);
      setImp(b, 'color', WHITE);
      setImp(b, 'border-radius', '18px');
      setImp(b, 'border-width', '3px');
      setImp(b, 'border-style', 'solid');
      setImp(b, 'border-color', INK);
      setImp(b, 'font-size', '17px');
      setImp(b, 'font-weight', '800');
      if (!b.classList.contains('es-sticky')) setImp(b, 'box-shadow', '5px 5px 0 ' + ORANGE);
      b.dataset.mvStyle = b.getAttribute('style');
    });
    traducir();
  }

  function traducir() {
    document.querySelectorAll('.es-popup-button-product .es-button-title, .es-popup-button-drawer .es-button-title, #es-sticky .es-button-title, #es-sticky span').forEach(function (s) {
      if (/cash on delivery|order now/i.test(s.textContent)) s.textContent = COD_LABEL;
    });
    var es = document.getElementById('easysell');
    if (!es) return;
    es.querySelectorAll('.es-city-group .es-label').forEach(function (l) {
      var n = l.firstChild;
      if (n && n.nodeType === 3 && /^\s*City\s*$/i.test(n.data)) n.data = 'Ciudad';
    });
    var city = document.getElementById('es-city');
    if (city && /^\s*City\s*$/i.test(city.placeholder)) city.placeholder = 'Ingresá tu ciudad o departamento';
    var sold = document.getElementById('es-soldout-label');
    if (sold && /sold out/i.test(sold.textContent)) sold.textContent = 'Agotado';
  }


  /* Precios sin decimales y con punto de miles en lo que pintan las apps (Kaching, EasySell)
     y el carrito lateral del tema: "$1.190,00" -> "$1.190" y "$1,190" -> "$1.190". */
  var RAICES = 'kaching-bundle, #easysell, cart-drawer, #CartDrawer, .cart-drawer';
  var RE_CENT = /(\$\s?\d{1,3}(?:\.\d{3})*),00(?!\d)/g;
  var RE_COMA = /(\$\s?)(\d{1,3})((?:,\d{3})+)(?![\d,])/g;
  function precios() {
    document.querySelectorAll(RAICES).forEach(function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        var t = n.data;
        if (t.indexOf('$') === -1) continue;
        var nt = t.replace(RE_COMA, function (m, p, a, b) { return p + a + b.replace(/,/g, '.'); }).replace(RE_CENT, '$1');
        if (nt !== t) n.data = nt;
      }
    });
  }

  /* "Pagar online · 5% OFF" del carrito: va al checkout con el cupón (el pago al recibir lo saca). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#CartDrawer-Checkout, button[name="checkout"]');
    if (!b || b.disabled) return;
    e.preventDefault(); e.stopImmediatePropagation();
    window.location.href = '/checkout?discount=PAGOONLINE5';
  }, true);

  pintar(); precios();
  document.addEventListener('DOMContentLoaded', function () { pintar(); precios(); });
  var pend = false;
  new MutationObserver(function () {
    if (pend) return; pend = true;
    setTimeout(function () { pend = false; pintar(); precios(); }, 30);
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
})();
